export const SSRGetDoneMark = {
  getDoneMark: () => null,
  setGetDoneMark: fn => {
    SSRGetDoneMark.getDoneMark = fn;
  }
};